import { render, staticRenderFns } from "./ImageAlignmentField.vue?vue&type=template&id=2be1dab9&scoped=true&"
import script from "./ImageAlignmentField.vue?vue&type=script&lang=js&"
export * from "./ImageAlignmentField.vue?vue&type=script&lang=js&"
import style0 from "./ImageAlignmentField.vue?vue&type=style&index=0&id=2be1dab9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be1dab9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VSubheader})
